<template>
    <div>
        <AlertDismiss ref="alert" />
        <BaseModal ref="modalEvaluation" v-model="showModal" size="lg">
            <EvaluationUserForm :evaluation="currentEvaluation" :questions="currentEvaluationQuestions" />
        </BaseModal>
        <EvaluationForm />
        <EvaluationQuestions />
        <EvaluationDelete />

        <b-overlay :show="loading" class="overlay">
        <b-table :items="localItems" :fields="fields" class="table-container" sticky-header="45vh">
            <template #cell(options)="data">
                <div class="d-flex align-items-center btn-group">
                    <b-button size="sm" @click="toggleDetails(data)" variant="light" class="mr-2 py-0">
                        <div v-if="data.detailsShowing" v-b-tooltip.hover.left="'Ocultar detalles'">
                            <b-icon icon="eye-slash-fill" variant="secondary" />
                        </div>
                        <div v-else v-b-tooltip.hover.left="'Ver detalles'">
                            <b-icon icon="eye-fill" variant="secondary" />
                        </div>
                    </b-button>

                    <button class="btn btn-light btn-sm py-0" @click="openEvaluation(data)" v-b-tooltip.hover.left
                        title="Responder evaluación">
                        <b-icon icon="list" variant="secondary"></b-icon>
                    </button>

                    <b-button v-permission="'capacitaciones-evaluacion-ver-respuestas'"
                        @click="openModalEvaluationCorrectAnswers(data.item)" type="button" variant="light"
                        v-b-tooltip.hover.left="'Ver respuestas'" size="sm" class="py-0 ms-2">
                        <b-icon icon="check2-circle" variant="secondary" />
                    </b-button>

                    <b-button v-permission="'capacitaciones-evaluacion-eliminar'" @click="toggleDeleteModal(data.item)"
                        type="button" variant="light" v-b-tooltip.hover.left="'Eliminar evaluación'" size="sm"
                        class="py-0">
                        <b-icon icon="trash" variant="secondary" />
                    </b-button>
                </div>
            </template>

            <!--cuerpo de detalle-->
            <template #row-details=row>
                <div class="card d-flex">
                    <div class="card-body p-2">
                        <EvaluationSummaryNote :summary="getRowSummary(row)" />
                        <EvaluationQualificationsList :items="getRowQualifications(row)" />
                    </div>
                </div>
            </template>

            <template #cell(approved)="row">
                <EvaluationApproved :approved="row.item.approved" />
            </template>
        </b-table>

        </b-overlay>

        <button v-permission="'capacitaciones-evaluacion-crear'" class="btn btn-outline-primary btn-sm"
            @click="addEvaluation">
            <b-icon icon="plus" />
            Añadir evaluación
        </button>
    </div>
</template>

<script>
import { EventNames } from '@/plugins/enums';
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import BaseModal from '@/components/shared/Base-modal.vue';
import EvaluationQualificationsList from './EvaluationTable/Evaluation-qualifications-list.vue';
import EvaluationSummaryNote from './EvaluationTable/Evalution-summary-note.vue';
import EvaluationUserForm from './EvaluationTable/Evaluation-user-form.vue';
import EvaluationForm from './EvaluationTable/Evaluation-form.vue';
import EvaluationQuestions from './EvaluationTable/Evaluation-questions.vue';
import EvaluationDelete from './EvaluationTable/Evaluation-delete.vue';
import EvaluationApproved from './EvaluationTable/Evaluation-approved.vue';

export default {
    name: 'Evaluation-table',

    props: {
        items: Array,
        curriculumId: String,
        courseId: String,
    },

    components: {
        BaseModal,
        AlertDismiss,
        EvaluationUserForm,
        EvaluationQualificationsList,
        EvaluationSummaryNote,
        EvaluationForm,
        EvaluationQuestions,
        EvaluationDelete,
        EvaluationApproved
    },

    data() {
        return {
            loading: false,
            localItems: [],
            fields: [
                { key: 'name', label: 'Nombre' },
                { key: 'approved', label: 'Estado', thClass: 'col-2' },
                { key: 'options', label: '', thClass: 'col-1' },
            ],

            showModal: false,
            currentEvaluation: null,
            currentEvaluationQuestions: null,
            evaluationsContent: {},
            evaluationsSummary: {},
        }
    },

    async mounted() {
        this.$eventBus.$on(EventNames.SubmittedEvaluation, (id) => {
            this.$refs.alert.showAlert('Evaluación enviada correctamente', 'success')
            this.showModal = false
            this.fetchEvalutionDetails(id)
            this.fetchEvalutionSummary(id)
            this.fetchAllApproved()
        })

        await this.fetchAllApproved()
    },

    methods: {
        ...mapActions([
            "allEvaluationAttemptsForPage",
            "getEvaluationById",
            "getEvaluationSummary",
            "getEvaluationApproval"
        ]),

        async openEvaluation(data) {
            this.showModal = true;
            this.currentEvaluation = data.item;
            let content = this.evaluationsContent[data.item.id]
            if (content === undefined) {
                await this.fetchEvalutionDetails(data.item.id)
                content = this.evaluationsContent[data.item.id]
            }

            this.currentEvaluationQuestions = content[0].questions
        },

        randomDateTime() {
            const start = new Date(2020, 0, 1);
            const end = new Date();
            return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
        },

        async fetchEvalutionDetails(id) {
            let result = await this.getEvaluationById({ evaluationId: id })
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }
            let content = result.data
            this.$set(this.evaluationsContent, id, content)
        },

        async fetchEvalutionSummary(id) {
            let result = await this.getEvaluationSummary({ evaluationId: id })
            if (result.isError) {
                this.$refs.alert.showAlert(result.message, 'warning')
                return
            }

            let content = result.data
            this.$set(this.evaluationsSummary, id, content)
        },

        async toggleDetails(row) {
            row.toggleDetails()
            let content = this.evaluationsContent[row.item.id]
            if (content === undefined) {
                await this.fetchEvalutionDetails(row.item.id)
            }

            let summary = this.evaluationsSummary[row.item.id]
            if (summary === undefined) {
                await this.fetchEvalutionSummary(row.item.id)
            }
        },

        getRowSummary(row) {
            return this.evaluationsSummary[row.item.id]
        },

        getRowQualifications(row) {
            return this.evaluationsContent[row.item.id]?.[0]?.qualifications
        },

        addEvaluation() {
            this.$eventBus.$emit(EventNames.OpenEvaluationFormModal, { curriculumId: this.curriculumId, courseId: this.courseId })
        },

        openModalEvaluationCorrectAnswers(item) {
            this.$eventBus.$emit(EventNames.OpenEvaluationQuestionsModal, item);
        },

        toggleDeleteModal(item) {
            this.$eventBus.$emit(EventNames.OpenModalDeleteEvaluation, { evaluation: item, courseId: this.courseId });
        },

        async fetchEvaluationApproved(evaluation) {
            let result = await this.getEvaluationApproval({ evaluationId: evaluation.id })
            if (result.isError) {
                this.$refs.alert.showAlert(result.message, 'warning')
                return
            }
            return result.data.approved
        },

        async fetchAllApproved() {
            this.loading = true
            this.localItems = await Promise.all(this.items.map(async (item) => {
                return {
                    ...item,
                    approved: await this.fetchEvaluationApproved(item)
                }
            }))
            this.loading = false
        }
    },

    watch: {
        items: {
            handler() {
                this.fetchAllApproved()
            },
            deep: true
        }
    }
}
</script>
